import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { AvatarModule } from '../../../../../../../components/avatar/avatar.module';
import { PatientCellComponent } from './patient-cell.component';

@NgModule({
  declarations: [PatientCellComponent],
  exports: [PatientCellComponent],
  imports: [
    CommonModule,
    AvatarModule,
    NgxBootstrapIconsModule,
    TooltipModule.forRoot(),
    BsDropdownModule,
    FormsModule,
  ],
})
export class PatientCellModule {}
